import { InjectionToken } from '@angular/core';
import {RawNotification} from "../../components/nav-bar/Models/notification.model";

// --- Domain Models ---

export type NotificationPriority = 'low' | 'normal' | 'high';

export interface AppNotification {
    id: string;
    title: string;
    body: string;
    createdAt: Date;
    type?: string;           // e.g. 'message', 'system'
    priority?: NotificationPriority; // default 'normal'
    route?: string;          // optional route to navigate on click
    payload?: any;           // extra data (pass your full existing Payload here)
    rawNotification?: RawNotification; // original notification object (e.g., from FCM)
}

export interface PushPreviewState {
    visible: AppNotification[];   // notifications currently shown as cards
    extraCount: number;           // number of notifications "behind"
    trayOpen: boolean;            // true if Notification Center tray is open
}

// --- Configuration ---

export interface PushPreviewConfig {
    maxVisibleCollapsed: number;              // default: 2
    autoCloseInCollapsed: boolean;            // default: true
    autoCloseTimeoutMsCollapsed: number;      // default: 8000
    autoCloseInExpanded: boolean;             // default: false
    autoCloseTimeoutMsExpanded: number;       // default: 8000
    refillFromBacklogOnAutoCloseInCollapsed: boolean; // default: false
    muteDurationAfterDismissAllMs: number; // Time to silence previews after "Dismiss All"
}

export const DEFAULT_PUSH_PREVIEW_CONFIG: PushPreviewConfig = {
    maxVisibleCollapsed: 2,
    autoCloseInCollapsed: true,
    autoCloseTimeoutMsCollapsed: 8000,
    autoCloseInExpanded: false,
    autoCloseTimeoutMsExpanded: 8000,
    refillFromBacklogOnAutoCloseInCollapsed: false,
    // --- NEW DEFAULT (e.g., 60 seconds) ---
    muteDurationAfterDismissAllMs: 60000,
};

export const PUSH_PREVIEW_CONFIG = new InjectionToken<PushPreviewConfig>(
    'PUSH_PREVIEW_CONFIG',
    {
        providedIn: 'root',
        factory: () => DEFAULT_PUSH_PREVIEW_CONFIG,
    }
);